import { render, staticRenderFns } from "./MusicAlbums.vue?vue&type=template&id=be6d3518&scoped=true&"
import script from "./MusicAlbums.vue?vue&type=script&lang=js&"
export * from "./MusicAlbums.vue?vue&type=script&lang=js&"
import style0 from "./MusicAlbums.vue?vue&type=style&index=0&id=be6d3518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6d3518",
  null
  
)

export default component.exports